import { GetServerSidePropsContext } from 'next';

export interface EmailCampaignsAddingProducts {
	partNumbers: string[];
	promoTitle?: string;
	contentConf?: string;
}

export const EMAIL_CAMPAIGN_QUERY_KEYS = {
	partNumbers: 'email_add_pn',
	promoTitle: 'email_promo_title',
	contentConf: 'email_content_conf',
} as const;

const firstQueryValue = (value?: string | string[]): string | undefined =>
	Array.isArray(value) ? value[0] : value;

export const getEmailCampaignsAddingProducts = (
	context: GetServerSidePropsContext
): EmailCampaignsAddingProducts | undefined => {
	const rawPartNumbers = firstQueryValue(context.query[EMAIL_CAMPAIGN_QUERY_KEYS.partNumbers]);
	if (!rawPartNumbers) return undefined;

	const partNumbers = rawPartNumbers
		.split(',')
		.map((pn) => pn.trim())
		.filter(Boolean);
	if (partNumbers.length === 0) return undefined;

	const promoTitle = firstQueryValue(context.query[EMAIL_CAMPAIGN_QUERY_KEYS.promoTitle])?.trim();

	const contentConf = firstQueryValue(context.query[EMAIL_CAMPAIGN_QUERY_KEYS.contentConf])?.trim();

	return {
		partNumbers,
		...(promoTitle ? { promoTitle } : {}),
		...(contentConf ? { contentConf } : {}),
	};
};
